import React, { useEffect, useState } from "react"
import { RenderStatement } from "."
import { useRenderStyling } from "lib/hooks/useRenderStyling"

export default function RenderStatementsByParent({ 
  elemtype="opening_statements", 
  statements=[],
  parent, 
  level 
}:{ 
  elemtype?:string
  statements:any[]
  parent:string[]
  level:number 
}) {
  
  // useEffect(() => {
  //   console.log(statements)
  //   console.log("statements to render:", statements.filter( (st:any) => st.parent[0] === parent[0] && st.level === level) )
  // },[])

  const outerStyling = useRenderStyling("w-full flex flex-col", "styleObj")

  return (
    <div {...outerStyling}>
      { statements.filter( (st:any) => st.parent[0] === parent[0] && st.level === level ).map( (statement:any) => (
        <RenderStatement key={statement.refstr} elemtype={elemtype} statement={statement} />
      ))}
    </div>
  )

}